import React, { useEffect, useState } from "react";
import { Col, Container, Input, Label, Row } from "reactstrap";
import DatePicker from "react-datepicker";
import moment from "moment";
import Select from "react-select";
import { getStatuses } from "../../actions/myobActions";

/**
 * @typedef ExportStatus
 * @property { number } id
 * @property { string } name
 * @property { "READY" | "EXPORTED" | "ERROR" | "EXPORTING" } code
 */

/**
 * @typedef MYOBListFiltersProps
 * @property { () => void } handleCreate
 * @property { () => void } handleResetFilter
 * @property { () => void } handleSearch
 * @property { {
 *  dateFrom: string,
 *  dateTo: string,
 *  clientName: string,
 *  status: string
 * } } filters
 * @property { ({value: any, field: string}) => void } handleFilterChange
 */

/**
 *
 * @param {MYOBListFiltersProps} Props
 * @returns
 */
const InvoiceListFilters = ({
  handleFilterChange,
  filters,
  handleCreate,
  handleResetFilter,
  handleSearch,
}) => {
  /**
   * @type {ExportStatus[]}
   */
  const defaultStatusList = [];

  const [statusList, setStatusList] = useState(defaultStatusList);

  async function fetchStatusLookup() {
    const res = await getStatuses();
    setStatusList(res || []);
  }

  useEffect(() => {
    fetchStatusLookup();
  }, []);

  return (
    <Container>
      <Row className="align-items-center mb-1">
        <Col sm={4} md={3}>
          <Label for="clientName">Client Name</Label>
        </Col>
        <Col sm={8} md={9}>
          <Input
            id="clientName"
            value={filters.clientName}
            onChange={(e) =>
              handleFilterChange({ value: e.target.value, field: "clientName" })
            }
            placeholder="Name"
          />
        </Col>
      </Row>
      <Row className="align-items-center full-width-datepicker">
        <Col sm={4} md={3}>
          <Label for="from">From</Label>
        </Col>
        <Col sm={8} md={4} className="mb-1">
          <DatePicker
            onChange={(date) =>
              handleFilterChange({ value: date, field: "dateFrom" })
            }
            value={filters.dateFrom || undefined}
            openToDate={filters.dateFrom ? moment(filters.dateFrom) : moment()}
            placeholderText="Date From"
            locale="en-au"
            readOnly={false}
            popperPlacement="bottom-end"
            popperModifiers={{
              offset: {
                enabled: true,
                offset: "5px, 10px",
              },
              preventOverflow: {
                enabled: true,
                escapeWithReference: false, // force popper to stay in viewport (even when input is scrolled out of view)
                boundariesElement: "viewport",
              },
            }}
            className="form-control"
          />
        </Col>
        <Col sm={4} md={1}>
          <Label for="to">To</Label>
        </Col>
        <Col sm={8} md={4} className="mb-1">
          <DatePicker
            onChange={(date) =>
              handleFilterChange({ value: date, field: "dateTo" })
            }
            value={filters.dateTo || undefined}
            openToDate={filters.dateTo ? moment(filters.dateTo) : moment()}
            placeholderText="Date To"
            locale="en-au"
            readOnly={false}
            popperPlacement="bottom-end"
            popperModifiers={{
              offset: {
                enabled: true,
                offset: "5px, 10px",
              },
              preventOverflow: {
                enabled: true,
                escapeWithReference: false, // force popper to stay in viewport (even when input is scrolled out of view)
                boundariesElement: "viewport",
              },
            }}
            className="form-control"
            minDate={filters.dateFrom ? moment(filters.dateFrom) : moment()}
          />
        </Col>
      </Row>
      <Row className="align-items-center mb-1">
        <Col sm={4} md={3}>
          <Label for="status">Status</Label>
        </Col>
        <Col sm={8} md={9}>
          <Select
            name="status"
            value={filters.status}
            clearable={false}
            options={statusList}
            simpleValue
            onChange={(value) => {
              handleFilterChange({ value, field: "status" });
            }}
            valueKey="code"
            labelKey="name"
          />
        </Col>
      </Row>
      <div className="mt-2">
        <button className="btn btn-primary" onClick={handleSearch}>
          <i className="fa fa-search" aria-hidden="true"></i> &nbsp;Search
        </button>
        <button className="btn btn-default ml-1" onClick={handleResetFilter}>
          Reset
        </button>
        <button className="btn btn-success ml-1 bold" onClick={handleCreate}>
          <i className="fa fa-plus" aria-hidden="true"></i> &nbsp;New Invoice
        </button>
      </div>
    </Container>
  );
};
export default InvoiceListFilters;
